import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { setAuthToken } from '../utils/auth';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post('https://apipublic.menuoff.com/login', formData, {
        withCredentials: true
      });

      if (response.data.ok) {
        navigate('/dashboard');
      } else {
        setError(response.data.message || 'خطا در ورود');
      }
    } catch (err) {
      console.error('Login Error Details:', {
        message: err.message,
        code: err.code,
        response: err.response ? {
          status: err.response.status,
          statusText: err.response.statusText,
          data: err.response.data
        } : 'No response',
        config: {
          url: err.config?.url,
          method: err.config?.method,
          baseURL: err.config?.baseURL
        }
      });
      
      if (err.code === 'ECONNREFUSED') {
        setError('سرور backend در حال اجرا نیست. لطفاً سرور را راه‌اندازی کنید.');
      } else if (err.response) {
        setError(err.response.data?.message || `خطای سرور: ${err.response.status}`);
      } else {
        setError(`خطا در اتصال: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h2>ورود به سیستم</h2>
          <p>لطفاً اطلاعات خود را وارد کنید</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">نام کاربری:</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              placeholder="نام کاربری خود را وارد کنید"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">رمز عبور:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="رمز عبور خود را وارد کنید"
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'در حال ورود...' : 'ورود'}
          </button>
        </form>

        <div className="login-footer">
          {/* <p>نام کاربری: admin | رمز عبور: admin</p> */}
        </div>
      </div>
    </div>
  );
};

export default Login;